import { ArrowRight } from '@1debit/icons';
import Button from 'components/shared/Buttons/BaseButton';
import NavLink from 'components/shared/NavLink/NavLink';
import { NavContentLinkProps } from './types';
import { MainNavLinkSize } from 'types/constants';
import { cn } from 'utils/styles';
import { generateNavId } from 'components/MainNav/utils';

export interface NavCoreButtonProps {
  linkContent: NavContentLinkProps;
  handleClick: (link: NavContentLinkProps) => void;
}
const NavCoreButton = ({ linkContent, handleClick }: NavCoreButtonProps) => {
  const { linkSize, link } = linkContent;
  const linkId = generateNavId(link);

  const sharedStyles = cn(
    {
      'text-heading-sm font-semibold leading-none': linkSize === MainNavLinkSize.Large,
      'text-body-saans leading-1.4 font-medium h-5': linkSize === MainNavLinkSize.Small,
    },
    'active:scale-none',
  );

  if (linkContent?.subMenu != null) {
    return (
      <Button variant="navMenu" className={cn(sharedStyles, 'group h-full')} onClick={() => handleClick(linkContent)}>
        <div className="flex gap-1 h-full text-kale items-center" id={linkId}>
          {link.label}
          <span className="w-6">
            <ArrowRight className="hidden group-hover:inline group-focus:inline size-(--ck-icon-size)" />
          </span>
        </div>
      </Button>
    );
  }

  return (
    <NavLink
      id={linkId}
      level={0}
      className={cn(sharedStyles, 'hover:text-fern focus:text-fern h-full font-sans')}
      href={link?.url}
      internalPage={link?.internalPage}
      sys={link?.sys}>
      {link.label}
    </NavLink>
  );
};

export default NavCoreButton;
